import { ListHttpResponse } from "../../_common/models/core.model";

export interface QueueStatusModel {
    method: string,
    status: string,
    quantity: number
}

export interface QueueStatusListResponse extends ListHttpResponse<QueueStatusModel> { }
